import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getVerracosConSeguimiento`, method: 'GET', body: null, token: token})
}